import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { AppConfigService } from '@app/core/services/app-config.service';
import { AppLocaleService } from '@core/services/app-locale.service';
import { Subscription, filter, take } from 'rxjs';

@Pipe({
	name: 'cassCurrency',
	pure: false
})
export class CassCurrencyPipe implements PipeTransform, OnDestroy {

	private _currencyCode?: string; // override from config - to be deprecated when currency is always present on orders
	lastInput: string | number | null | undefined;
    lastOutput: string | undefined;
    currentLocale$?: Subscription;

	constructor(private _appLocaleService: AppLocaleService, private _appConfigService: AppConfigService) {
		this._appConfigService.config$.pipe(
			filter(config => !!config),
			take(1)
			).subscribe(config => {
				this._currencyCode = config?.currencyCode;
			}
		);
		this.currentLocale$ = this._appLocaleService.currentLocale$.subscribe(_ => {
			this.lastInput = undefined;
			this.lastOutput = undefined;
		});
	}

	ngOnDestroy(): void {
        this.currentLocale$?.unsubscribe();
    }

	transform(value: number | null | undefined, currencyCode?: string): string | undefined {
		if (value === this.lastInput) {
			return this.lastOutput;
        }
		if (value === undefined || value === null) return;
        this.lastInput = value;
		currencyCode = this._currencyCode || currencyCode || '';
		let currencySymbol = currencyCode ? getCurrencySymbol(currencyCode, 'wide', this._appLocaleService.currentOrDefaultLocaleId) : '';
		this.lastOutput = formatCurrency(value, this._appLocaleService.currentOrDefaultLocaleId, currencySymbol, currencyCode);
		return this.lastOutput;
	}
}
